import React from "react";
import "./PoliciesPages.scss";

const Privacy = () => {
    return (
        <div className="policy-page">
            <h1>Privacy Notice</h1>

            <p><strong>Version:</strong> 1.1</p>
            <p><strong>Date:</strong> 01.01.2025</p>
            <p><strong>Author:</strong> Afzal Mahmood of Ranna</p>
            <p><strong>Stored at:</strong> Policy and Procedure Filing</p>

            <h2>1. Introduction</h2>
            <p>
                Old Kent Shisha Lounge (“we”, “our”, “us”) is committed to protecting the
                privacy and personal data of all customers, visitors, and individuals who
                interact with our services. This Privacy Notice explains how we collect,
                use, store, and protect your personal information in accordance with UK
                GDPR and the Data Protection Act 2018.
            </p>

            <h2>2. Data We Collect</h2>
            <h3>Personal Identification Information</h3>
            <ul>
                <li>Full name</li>
                <li>Phone number</li>
                <li>Email address</li>
                <li>Date of birth (for age verification)</li>
            </ul>

            <h3>Booking & Reservation Information</h3>
            <ul>
                <li>Group size</li>
                <li>Booking date/time</li>
                <li>Special requests</li>
            </ul>

            <h3>Communication Records</h3>
            <ul>
                <li>Messages submitted through our website</li>
                <li>Emails or phone enquiries</li>
            </ul>

            <h3>Site & Security Information</h3>
            <ul>
                <li>CCTV footage</li>
                <li>IP/analytics data</li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <ul>
                <li>To manage bookings and enquiries</li>
                <li>To maintain safety and compliance</li>
                <li>To improve services and customer experience</li>
                <li>To fulfil legal obligations</li>
            </ul>

            <h2>4. Legal Bases for Processing</h2>
            <ul>
                <li><strong>Consent</strong> — voluntary submissions</li>
                <li><strong>Contract</strong> — booking fulfilment</li>
                <li><strong>Legal obligation</strong> — regulatory compliance</li>
                <li><strong>Legitimate interests</strong> — venue safety & fraud prevention</li>
            </ul>

            <h2>5. CCTV & Surveillance</h2>
            <ul>
                <li>CCTV is used throughout the premises for safety and crime prevention.</li>
                <li>Footage may be shared with law enforcement when required.</li>
                <li>Access is restricted to authorised personnel only.</li>
            </ul>

            <h2>6. Data Storage & Protection</h2>
            <ul>
                <li>Personal data is stored securely using protected systems.</li>
                <li>Access is restricted to trained and authorised staff.</li>
                <li>
                    We apply industry-standard technical and organisational controls to
                    prevent loss, misuse, or unauthorised access.
                </li>
            </ul>

            <h2>7. Security</h2>
            <p>We take security seriously and use the following measures to protect personal data:</p>
            <ul>
                <li><strong>SSL encryption</strong> for all websites and online transactions</li>
                <li><strong>Firewalls and intrusion protection</strong> to prevent unauthorised access</li>
                <li><strong>UK-based secure servers</strong> with GDPR-compliant sub-processors</li>
                <li><strong>Staff access restrictions</strong> to protect sensitive data</li>
                <li><strong>Staff training</strong> in safe data handling</li>
            </ul>

            <h2>8. Data Retention</h2>
            <ul>
                <li>Bookings: retained for up to 12 months</li>
                <li>Website enquiries: retained for up to 6 months</li>
                <li>CCTV footage: stored for 30–60 days unless required for investigation</li>
            </ul>

            <h2>9. Your Rights Under UK GDPR</h2>
            <ul>
                <li>Right to access</li>
                <li>Right to rectification</li>
                <li>Right to erasure</li>
                <li>Right to restrict processing</li>
                <li>Right to object</li>
                <li>Right to data portability</li>
                <li>Right to withdraw consent</li>
            </ul>

            <h2>10. Sharing Your Information</h2>
            <ul>
                <li>We do not sell your data.</li>
                <li>Data may be shared with trusted providers or authorities where necessary.</li>
                <li>All third parties must meet GDPR requirements.</li>
            </ul>

            <h2>11. International Data Transfers</h2>
            <p>
                We do not transfer personal data outside the UK unless appropriate safeguards
                or adequacy decisions are in place.
            </p>

            <h2>12. Updates to This Privacy Notice</h2>
            <p>
                This notice may be updated when necessary. The most current version will be
                available on our website and stored in our Policy and Procedure Filing system.
            </p>

            {/* ⭐ UPDATED GDPR REFERENCE SECTION ⭐ */}
            <h2>13. GDPR Compliance</h2>
            <p>
                Old Kent Shisha Lounge complies fully with the UK General Data Protection 
                Regulation (UK GDPR) and the Data Protection Act 2018.  
                For full details on your rights, lawful bases for processing, our data 
                protection commitments, and our breach procedures, please refer to our 
                separate GDPR Policy.
            </p>
            <p>
                You may review the full GDPR Policy here: <strong>/policies/gdpr</strong>
            </p>

            <h2>14. Cookies & Tracking</h2>
            <p>
                Our website uses cookies and similar tracking technologies to improve
                functionality, enhance user experience, and analyse website performance.
            </p>

            <h3>Types of Cookies We Use</h3>
            <ul>
                <li><strong>Essential cookies</strong> – required for site functionality</li>
                <li><strong>Performance cookies</strong> – understand how visitors use our site</li>
                <li><strong>Functionality cookies</strong> – remember preferences</li>
                <li><strong>Analytics cookies</strong> – anonymised visitor statistics</li>
            </ul>

            <h3>How You Can Control Cookies</h3>
            <ul>
                <li>Accept or reject non-essential cookies</li>
                <li>Disable cookies via browser settings</li>
                <li>Delete cookies stored on your device</li>
            </ul>

            <h3>Third-Party Tracking</h3>
            <p>Third-party providers (e.g., analytics) must comply with GDPR.</p>

            <h2>15. Contact Information</h2>
            <p><strong>Old Kent Shisha Lounge</strong></p>
            <p>Email: hello@oldkent-shisha.co.uk</p>
            <p>Phone: 020 7701 4646</p>
            <p>Address: 350 Old Kent Road, London SE1 5AA</p>

        </div>
    );
};

export default Privacy;
